<nz-affix [nzOffsetTop]="0">
  <hx-breadcrumbs></hx-breadcrumbs>
  <nz-page-header nzBackIcon [nzGhost]="false">
    <nz-page-header-title>{{(isEdit ? 'action.edit' : 'action.create') | transloco}}</nz-page-header-title>
  </nz-page-header>
</nz-affix>
<nz-skeleton [nzActive]="true" [nzLoading]="isLoading.model">
  <form nz-form class="hx-form" [nzLayout]="'vertical'" [formGroup]="form" (ngSubmit)="submitForm()" *transloco="let tr; prefix: 'stores'; scope: 'stores'">
    <div nz-row [nzGutter]="8">
      <div nz-col class="hx-col-2">
        <nz-form-item>
          <nz-form-label nzRequired>{{tr('form.title')}}</nz-form-label>
          <nz-form-control>
            <hx-label-edit formControlName="title"></hx-label-edit>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col class="hx-col-1">
        <nz-form-item>
          <nz-form-label nzRequired>{{tr('form.brandId')}}</nz-form-label>
          <nz-form-control>
            <hx-brand-select formControlName="brandId"></hx-brand-select>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>
    <div nz-row [nzGutter]="8">
      <div nz-col>
        <nz-form-item>
          <nz-form-label nzRequired>{{tr('form.timezone')}}</nz-form-label>
          <nz-form-control>
            <input nz-input formControlName="timezone"/>
          </nz-form-control>
        </nz-form-item>
      </div>

      <div nz-col>
        <nz-form-item>
          <nz-form-label nzRequired>{{tr('form.enabled')}}</nz-form-label>
          <nz-form-control>
            <nz-radio-group formControlName="enabled">
              <label nz-radio [nzValue]="true">{{'yes' | transloco}}</label>
              <label nz-radio [nzValue]="false">{{'no' | transloco}}</label>
            </nz-radio-group>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <div nz-row [nzGutter]="8">
      <div nz-col>
        <nz-form-item>
          <nz-form-label nzRequired>{{tr('form.countryId')}}</nz-form-label>
          <nz-form-control>
            <hx-country-select formControlName="countryId"></hx-country-select>
          </nz-form-control>
        </nz-form-item>
      </div>

      <div nz-col>
        <nz-form-item>
          <nz-form-label nzRequired>{{tr('form.cityId')}}</nz-form-label>
          <nz-form-control>
            <hx-city-select formControlName="cityId"></hx-city-select>
          </nz-form-control>
        </nz-form-item>
      </div>

      <div nz-col>
        <nz-form-item>
          <nz-form-label nzRequired>{{tr('form.organizationId')}}</nz-form-label>
          <nz-form-control>
            <hx-org-select formControlName="organizationId"></hx-org-select>
          </nz-form-control>
        </nz-form-item>
      </div>

    </div>

    <div nz-row [nzGutter]="8">
      <div nz-col class="hx-col-2">
        <nz-form-item>
          <nz-form-label nzRequired>{{tr('form.address')}}</nz-form-label>
          <nz-form-control>
            <input nz-input formControlName="address"/>
          </nz-form-control>
        </nz-form-item>
      </div>

      <div nz-col>
        <nz-form-item>
          <nz-form-label nzRequired>{{tr('form.latitude')}}</nz-form-label>
          <nz-form-control>
            <nz-input-number formControlName="latitude"></nz-input-number>
          </nz-form-control>
        </nz-form-item>
      </div>

      <div nz-col>
        <nz-form-item>
          <nz-form-label nzRequired>{{tr('form.longitude')}}</nz-form-label>
          <nz-form-control>
            <nz-input-number formControlName="longitude"></nz-input-number>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <div nz-row [nzGutter]="8">
      <div nz-col>
        <nz-form-item>
          <nz-form-label nzRequired>{{tr('form.hasOnlineSell')}}</nz-form-label>
          <nz-form-control>
            <nz-radio-group formControlName="hasOnlineSell">
              <label nz-radio [nzValue]="true">{{'yes' | transloco}}</label>
              <label nz-radio [nzValue]="false">{{'no' | transloco}}</label>
            </nz-radio-group>
          </nz-form-control>
        </nz-form-item>
      </div>

      <div nz-col>
        <nz-form-item>
          <nz-form-label nzRequired>{{tr('form.hasPickup')}}</nz-form-label>
          <nz-form-control>
            <nz-radio-group formControlName="hasPickup">
              <label nz-radio [nzValue]="true">{{'yes' | transloco}}</label>
              <label nz-radio [nzValue]="false">{{'no' | transloco}}</label>
            </nz-radio-group>
          </nz-form-control>
        </nz-form-item>
      </div>

      <div nz-col>
        <nz-form-item>
          <nz-form-label nzRequired>{{tr('form.hasDelivery')}}</nz-form-label>
          <nz-form-control>
            <nz-radio-group formControlName="hasDelivery">
              <label nz-radio [nzValue]="true">{{'yes' | transloco}}</label>
              <label nz-radio [nzValue]="false">{{'no' | transloco}}</label>
            </nz-radio-group>
          </nz-form-control>
        </nz-form-item>
      </div>

      <div nz-col>
        <nz-form-item>
          <nz-form-label nzRequired>{{tr('form.hasOnlineDelivery')}}</nz-form-label>
          <nz-form-control>
            <nz-radio-group formControlName="hasOnlineDelivery">
              <label nz-radio [nzValue]="true">{{'yes' | transloco}}</label>
              <label nz-radio [nzValue]="false">{{'no' | transloco}}</label>
            </nz-radio-group>
          </nz-form-control>
        </nz-form-item>
      </div>

      <div nz-col>
        <nz-form-item>
          <nz-form-label nzRequired>{{tr('form.hasDecoration')}}</nz-form-label>
          <nz-form-control>
            <nz-radio-group formControlName="hasDecoration">
              <label nz-radio [nzValue]="true">{{'yes' | transloco}}</label>
              <label nz-radio [nzValue]="false">{{'no' | transloco}}</label>
            </nz-radio-group>
          </nz-form-control>
        </nz-form-item>
      </div>

      <div nz-col>
        <nz-form-item>
          <nz-form-label nzRequired>{{tr('form.hasInscription')}}</nz-form-label>
          <nz-form-control>
            <nz-radio-group formControlName="hasInscription">
              <label nz-radio [nzValue]="true">{{'yes' | transloco}}</label>
              <label nz-radio [nzValue]="false">{{'no' | transloco}}</label>
            </nz-radio-group>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <div nz-row [nzGutter]="8">
      <div nz-col>
        <nz-form-item>
          <nz-form-label nzRequired>Slug</nz-form-label>
          <nz-form-control>
            <input nz-input formControlName="slug"/>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col>
        <nz-form-item>
          <nz-form-label nzRequired>{{tr('form.startWorkDate')}}</nz-form-label>
          <nz-form-control>
            <nz-date-picker formControlName="startWorkDate"></nz-date-picker>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col>
        <nz-form-item>
          <nz-form-label>{{tr('form.endWorkDate')}}</nz-form-label>
          <nz-form-control>
            <nz-date-picker formControlName="endWorkDate"></nz-date-picker>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <div nz-row [nzGutter]="8">
      <div nz-col>
        <nz-form-item>
          <nz-form-label nzRequired>{{tr('form.currency')}}</nz-form-label>
          <nz-form-control>
            <hx-enum-select [enumType]="Currency" enumName="Currency" formControlName="currency"></hx-enum-select>
          </nz-form-control>
        </nz-form-item>
      </div>

      <div nz-col class="hx-col-2">
        <nz-form-item>
          <nz-form-label>
            {{tr('form.callCenterPhone')}}
            <i style="margin-left: 1rem;" nz-icon [nz-tooltip]="tr('form.callCenterPhone.info')" nzType="question-circle" nzTheme="outline"></i>
          </nz-form-label>
          <nz-form-control>
            <input nz-input formControlName="callCenterPhones"/>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <div nz-row [nzGutter]="8">
      <div nz-col class="hx-col-4">
        <nz-form-item>
          <nz-form-label>{{tr('form.retailOutlet')}}</nz-form-label>
          <nz-form-control>
            <hx-store-select formControlName="retailOutletIds" [hxMode]="'multiple'"></hx-store-select>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <nz-divider nzDashed="true" [nzText]="tr('form.workTime')" nzOrientation="left"></nz-divider>

    <div nz-row [nzGutter]="8">
      <div nz-col *ngFor="let workTime of workTimes; let ix = index;">
        <nz-form-item [formGroup]="workTime">
          <nz-form-label [nzSm]="20" [nzXs]="24" nzRequired>
            {{tr('form.workTime.' + workTime.controls['dayOfWeek'].value)}}
          </nz-form-label>
          <nz-form-control>
            <nz-input-group nzCompact>
              <nz-time-picker formControlName="openTime" style="width:100px; text-align: center;" nzFormat="HH:mm"></nz-time-picker>
              <input
                type="text"
                disabled
                nz-input
                placeholder="~"
                style="width: 30px; border-left: 0px; pointer-events: none; background-color: rgb(255, 255, 255);"
              />
              <nz-time-picker formControlName="closeTime" style="width:100px; text-align: center;" nzFormat="HH:mm"></nz-time-picker>
            </nz-input-group>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <nz-alert *ngIf="form.invalid" nzType="error" [nzMessage]="'error.fillRequiredFields' | transloco" nzShowIcon></nz-alert>

    <div nz-row [nzGutter]="8" class="cp_actions">
      <div nz-col>
        <nz-form-item>
          <nz-form-control>
            <button [nzLoading]="isSaving" [disabled]="form.pristine || form.pending" type="submit" nz-button nzType="primary">
              <i nz-icon nzType="save" nzTheme="outline"></i> {{'button.save' | transloco}}
            </button>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col>
        <nz-tag nzColor="success" *ngIf="form.pristine && model.id">
          <i nz-icon nzType="check-circle"></i>
          <span>{{'form.saved' | transloco}}</span>
        </nz-tag>
      </div>
    </div>
  </form>
</nz-skeleton>
